




















































































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  computed,
} from '@vue/composition-api'

import { createUser } from '@/shared/api'
import { roles } from '@/shared/user/roles'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { Textbook, TextbookIssue } from '@/shared/types'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'CreateUser',
  components: {
    CloseButton,
  },
  setup(props, { root, emit }) {
    const CreateUserForm = ref(null)
    const data = reactive({
      valid: true,
      email: '',
      firstname: '',
      lastname: '',
      password: '',
      passwordConfirm: '',
      allowedTextbooks: [],
      allowedTextbookIssues: [],
      notifyUser: false,
      role: '',
      passwordVisible: false,
      passwordVisible2: false,
    })

    const rules = reactive({
      passwordConfirmRules: [
        () => {
          return (
            data.passwordConfirm === data.password ||
            root.$t('createUserForm.passwordConfirm.invalid')
          )
        },
      ],
      passwordRules: [
        (v: string) =>
          (!!v && v.length >= 8) || root.$t('login.password.invalid_length'),
        (v: string) => {
          const result = v.match(/^.*(?=\S*[\W]).*$/)
          return (
            (result && result.length && result[0] !== '') ||
            root.$t('login.password.specialCharacter')
          )
        },
      ],
      emailRules: [
        (v: string) => !!v || root.$t('inviteUserForm.email.required'),
        (v: string) =>
          /.+@.+\..+/.test(v) || root.$t('inviteUserForm.email.invalid'),
      ],
      nameRules: [
        (v: string) => !!v || root.$t('inviteUserForm.name.required'),
      ],
      roleRules: [
        (v: string) => !!v || root.$t('inviteUserForm.role.required'),
      ],
    })
    const { textbooks } = useTextbookStore().getters

    const loading = ref(false)

    const textbookIssues = computed(() =>
      textbooks.value.reduce(
        (issues, textbook) => [...issues, ...textbook.issues],
        []
      )
    )
    const allowedRoles = Object.keys(roles).map((roleName: string) => ({
      value: roleName,
      label: root.$t(`role.${roleName}`),
    }))

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = CreateUserForm.value

      if (!form.validate()) {
        return
      }
      loading.value = true
      try {
        const textbookIds = data.allowedTextbooks.map(
          (textbook: Textbook) => textbook.id
        )
        const textbookIssueIds = data.allowedTextbookIssues.map(
          (textbookIssue: TextbookIssue) => textbookIssue.id
        )
        const createdUser = await createUser(
          data.email,
          data.password,
          data.firstname,
          data.lastname,
          data.role,
          textbookIds,
          textbookIssueIds,
          data.notifyUser
        )
        loading.value = false
        emit('user-created', createdUser)
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      ...toRefs(rules),
      loading,
      CreateUserForm,
      submit,
      textbooks,
      textbookIssues,
      allowedRoles,
    }
  },
})
